import { ActionT } from '../../framework/framework/components/Types';
import { SelectComp } from '../select/SelectComp';
import { MenuItem } from '@material-ui/core';
import React = require('react');

interface IProps {
    onChange:ActionT<number>;
    value: number
}
interface IState {

}

export default class NumberInput extends React.Component<IProps, IState> {
    render() {
        return (
            <SelectComp value={this.props.value}
                variant={'outlined'}
                onChange={(e) => this.onChange(e)} >
                <MenuItem value={'1'}>1 </MenuItem>
                <MenuItem value={'2'}>2 </MenuItem>
                <MenuItem value={'3'}>3 </MenuItem>
                <MenuItem value={'4'}>4 </MenuItem>
                <MenuItem value={'5'}>5 </MenuItem>
                <MenuItem value={'6'}>6 </MenuItem>
                <MenuItem value={'7'}>7 </MenuItem>
                <MenuItem value={'8'}>8 </MenuItem>
                <MenuItem value={'9'}>9 </MenuItem>

            </SelectComp>
        );
    }

    onChange(e: any) {
        const value = parseInt(e.target.value);
        if (value > 0) { this.props.onChange(value); }
    }
}
